import { PageHeader } from '../../components/PageHeader';
import { PlanesTable } from './components/PlanesTable';

export function PlanesListPage() {
  return (
    <div>
      <PageHeader title="Planes" subtitle="Planes disponibles para los servicios de los clientes" />
      <PlanesTable />
    </div>
  );
}
